import { cn } from '#/lib/utils';

import { AnimatedBorderGenerator } from './AnimatedPathGenerator';

export function CardIconBlock({
  text,
  iconStack,
  iconBlockId,
  className,
}: {
  text: string | React.ReactNode;
  iconStack?: React.ReactNode;
  iconBlockId: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'bg-charcoal py-15 px-10 flex flex-col gap-15 m:min-w-160 m:max-w-190 max-w-135 w-full text-center items-center justify-center rounded-19 relative aspect-square',
        className,
      )}
    >
      <AnimatedBorderGenerator
        borderRadius={18}
        strokeWidth={1}
        topMotionId={`${iconBlockId}-top-motion`}
        bottomMotionId={`${iconBlockId}-bottom-motion`}
      />
      {iconStack}
      <span className="text-12 m:text-14 font-[500] leading-140 text-grayscale-01 text-pretty">
        {text}
      </span>
    </div>
  );
}
